var m = require('mithril');

var layout = require('../layout/layout');
var modalForm = require('../layout/components/modalForm');
var networkOverviewPage = require('../network/components/networkOverviewPage');
var hostPage = require('../network/components/hostPage');
var resourcePage = require('../network/components/resourcePage');

var modbusDevice = require('./modbusDevice');
var modbusTcpForm = modalForm(require('./models/modbusTcp'));
var modbusDeviceForm = modalForm(require('./models/modbusDevice'));
var modbusAddressForm = modalForm(require('./models/modbusAddress'));

var routes = {
  '/modbustcp': {
    view: function() {
      return m(layout, m(networkOverviewPage,{form:modbusTcpForm, activeTab:'Networks'}));
    }
  },
  '/modbustcp/:id': {
    view: function() {
      return m(layout, m(hostPage,{recordModel:modbusTcpForm,form:modbusDeviceForm,activeTab:'Networks'}));
    }
  },
  '/modbusdevice/:id': {
    view: function() {
      return m(layout, m(modbusDevice,{activeTab:'Networks'}));
    }
  },
  '/modbusaddress/:id': {
    view: function() {
      return m(layout, m(resourcePage,{recordModel:modbusAddressForm,activeTab:'Networks'}));
    }
  }
};

module.exports = routes;
